module.exports = __webpack_public_path__ + "static/media/login-username.60f97113.svg";